export const auth = {
  login: 'Sign In',
  logout: 'Sign Out',
  username: 'Username',
  email: 'Email',
  password: 'Password',
  forgotPassword: 'Forgot password?',
  invalidCredentials: 'Invalid credentials',
  accountLocked: 'Account is locked. Please try again later.',
  accountDisabled: 'Account is disabled',
  twoFactorRequired: '2FA code required',
  loginSuccess: 'Login successful',
  welcomeBack: 'Welcome back',
  signInPrompt: 'Sign in to access your admin dashboard',
  emailOrUsername: 'Email or Username',
  enterEmail: 'Enter your email',
  enterPassword: 'Enter your password',
  developmentCredentials: 'Development Credentials',
  loginPageTitle: 'Manage your EV charging network efficiently',
  loginPageSubtitle: 'Monitor charging stations, track usage analytics, manage users, and optimize your electric vehicle infrastructure all in one place.',
  twoFactorCode: 'Two-Factor Authentication Code',
  enter6DigitCode: 'Enter 6-digit code',
  twoFactorHint: 'Enter the code from your authenticator app',
  verifyAndSignIn: 'Verify & Sign In',
};